// на момент написания (02.04.2025) отличается от ai-form-text-box-virtual-grid-dictionary.vue использованием компонента
// pca-dictionary-virtual-grid.vue вместо ai-dictionary-virtual-grid.vue и установленным свойством
:need-modified-class="false" // а также изменённой функцией userDataChange
<template>
    <ai-form-text-box-dictionary
        ref="tbdRef"
        :display-expr="meta.extParams.displayExpr"
        :value-expr="meta.extParams.valueExpr"
        :field-name-id="meta.fieldNameId"
        :field-name-text="meta.fieldNameText"
        :title="meta.title"
        :validationRules="meta.validationRules"
        :data-source="dict"
        :callbacks="{ ...callbacks, dotsClick }"
        :need-modified-class="false"
        @popupShown="popupShown"
    >
        <pca-dictionary-virtual-grid
            ref="dvgRef"
            :meta="meta.extParams"
            :current-value="userData[meta.fieldNameText]"
            @dictionarySelectionChanged="selectionChanged"
        />
    </ai-form-text-box-dictionary>
</template>
<script setup>
import { computed, inject, ref } from 'vue';

import AiFormTextBoxDictionary from '@/components/card-component/ai-form-text-box-dictionary.vue';
import PcaDictionaryVirtualGrid from '@/views/contracts/print-contract/components/pca-dictionary-virtual-grid.vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {},
    },
    callbacks: {
        type: Object,
        default: () => ({
            userDataChanged: null,
            dotsClick: () => {
                console.log('aiFormTextBoxVirtualGridDictionary, dotsClick');
            },
        }),
    },
});

const dotsClick = () => {};

const userData = inject('userData');
const validationResult = inject('validationResult');
const tbdRef = ref(null);
const dvgRef = ref(null);
const dict = computed(() => {
    return [
        {
            [`${props.meta.extParams.valueExpr}`]: userData.value[props.meta.fieldNameId],
            [`${props.meta.extParams.displayExpr}`]: userData.value[props.meta.fieldNameText],
        },
    ];
});
const popupShown = () => {
    dvgRef.value.gridInstance.loadData();
};

// изменённая функция
const userDataChange = value => {
    validationResult.value = validationResult.value.filter(s => {
        return s.fieldNameText !== props.meta.fieldNameText;
    });

    const listText = [];
    const listId = [];
    for (let i = 0; i < value.length; i++) {
        listText.push(value[i][props.meta.extParams.displayExpr]);
        listId.push(value[i][props.meta.extParams.valueExpr]);
    }

    userData.value[props.meta.fieldNameText] = listText.join('; ');
    userData.value[props.meta.fieldNameId] = listId;

    props.meta.extParams.additionalFiels?.forEach(item => {
        userData.value[item.cardFieldName] = value[item.dictFieldName];
    });

    props.callbacks.userDataChanged(value);
};

const selectionChanged = async event => {
    userDataChange(event);
    tbdRef.value?.popupInstance.hide();
};
</script>
